<mat-card>
  <h1>
    ￥{{ data?.total_commission | number }}
    <mat-icon>wallet</mat-icon>
  </h1>
  <h2>总计佣金</h2>
  <span>历史佣金总和</span>
</mat-card>
